import { render, staticRenderFns } from "./MediaThumb.vue?vue&type=template&id=2b322222&scoped=true&"
import script from "./MediaThumb.vue?vue&type=script&lang=js&"
export * from "./MediaThumb.vue?vue&type=script&lang=js&"
import style0 from "./MediaThumb.vue?vue&type=style&index=0&id=2b322222&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b322222",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoPlayer: require('/opt/build/repo/components/VideoPlayer.vue').default,ButtonPlay: require('/opt/build/repo/components/ButtonComponents/ButtonPlay.vue').default})
